import { createSlice } from "@reduxjs/toolkit";
import {
    getAllDepartmentList
} from './thunk';

export const initialState = {
    departmentList: [],
    errors: {}
};

const DepartmentSlice = createSlice({
    name: 'Department',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getAllDepartmentList.fulfilled, (state: any, action: any) => {
            state.departmentList = action.payload;
        });
        builder.addCase(getAllDepartmentList.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
    }
});

export default DepartmentSlice.reducer;